import UpdoxApi from './updoxapi';

const headers = {'Content-Type': 'application/json'};

const getAuditActions = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/audit/actions',
    headers,
    successCallback,
    errorCallback,
  );
};

const getAuditLog = (payload, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/audit/search',
    headers,
    JSON.stringify(payload),
    successCallback,
    errorCallback,
  );
};

const AuditLogApi = { getAuditActions, getAuditLog };

export default AuditLogApi;



// WEBPACK FOOTER //
// ./src/apis/auditlog.js